import React, { useCallback, useState, useEffect } from "react";
import styled from "styled-components";
import Modal from "react-modal";
import { injectIntl } from 'react-intl'
import DotLoader from '../Common/Loaders/DotLoader'

import { Button, ButtonInner } from './styled'


const Footer = styled.div`
  display:flex;
  justify-content: space-between;
`

const style = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    backgroundColor: 'rgba(255, 255, 255, 0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  content: {
    position: 'unset',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '25px',
  }
}

const Content = styled.div`

`



const ModalWrapper = styled.div`
  display:flex;
  background-color:white;
  flex-direction:column;
  justify-content:space-between;
  height:100%;
  min-height:300px;
  min-width: 300px;

`

export default injectIntl(props => {
  const { extra = {}, disabled = false, onClick, dispatchEvent = () => { }, builder, intl, value, id, save, loading, name } = props;


  const [showConfirm, setShowConfirm] = useState(false);

  const {
    label = "No label",
    color = "primary",
    naked = false,
    showConfirmation = false,
    confirm = {},
    fluid = false,
    setValue = false,
    inverted = false,
    css = null
  } = extra;

  const { heading = 'Confirm', text = 'Are you sure?', ok = 'Yes', cancel = 'Cancel' } = confirm;

  const clicked = useCallback(e => {

    if (showConfirm) {
      setShowConfirm(false)
    }

    if (setValue) {
      save({ key: id, value: value ? false : true });
    }


    if (onClick) {
      onClick(e)
    } else {
      dispatchEvent("onClick")
    }
  }, [setShowConfirm, showConfirm, dispatchEvent, onClick])

  return (
    <React.Fragment>
      <Button
        name={name}
        disabled={disabled}
        fluid={fluid}
        naked={naked}
        inverted={inverted}
        color={color}
        inlineCSS={css}
        onClick={
          disabled || builder
            ? () => { }
            : showConfirmation
              ? () => setShowConfirm(true)
              : clicked
        }
      >
        {
          loading && <DotLoader background={'white'} delay={0} />
        }
        {
          !loading && (
            <ButtonInner disabled={disabled} color={color} naked={naked} inverted={inverted}>
              {label && intl.formatMessage({ id: label })}
            </ButtonInner>
          )
        }

      </Button>
      <Modal
        isOpen={showConfirm}
        style={style}
        aria={{
          labelledby: "heading",
          describedby: "full_description"
        }}
      >
        <ModalWrapper>
          <Content>
            <h1 id="heading">{heading}</h1>
            <div id="full_description">
              <p>{text}</p>
            </div>
          </Content>
          <Footer className="modal-footer">
            <Button name="_cancel" color={'danger'} onClick={() => setShowConfirm(false)}><ButtonInner disabled={false} color={'danger'}>{cancel}</ButtonInner></Button>
            <Button name="_success" color={'success'} onClick={clicked}><ButtonInner disabled={false} color={'success'}>{ok}</ButtonInner></Button>
          </Footer>

        </ModalWrapper>
      </Modal>
    </React.Fragment>
  );
});
